// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../writer-core-master/Product/ItSymphony.Writer.Web/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../writer-core-master/Product/ItSymphony.Writer.Web/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.topic-search-container {
  height: 100%;
  width: 100%;
}

.topic-search-header {
    font-size: 4rem;
    font-weight: bold;
    overflow: hidden;
    text-overflow: ellipsis;
}

.topic-pairs-search-input {
  margin: 1.5rem 4rem;
  height: 4rem;
  line-height: 4rem;
  width: 50%;
  float: left;
}

.topic-pairs-search-table {
  height: calc(100% - 13rem);
  width: 100%;
  overflow: auto;
  position: relative;
}

.topic-pairs-search-table__header {
  display: grid;
  grid-template-columns: 1fr 1fr 0.5fr;
  padding: 1rem;
  font-weight: bold;
}

.topic-pairs-search-table__body {
  padding: 1rem;
}

.topic-pairs-search-table__item {
  width: 100%;
  height: 100%;
  position: relative;
  margin-top: 1rem;
  margin-bottom: 1rem;
  line-height: 3.5rem;
  background-color: #fff;
  box-shadow: 0 2px 2px 0 rgb(0 0 0 / 14%), 0 3px 1px -2px rgb(0 0 0 / 12%),
    0 1px 5px 0 rgb(0 0 0 / 20%);
  border-radius: 2px;
  padding: 1rem 2rem;
  overflow: hidden;
  min-width: 60rem;
  display: flex;
  flex-direction: column;
}

.show-hide-checkbox {
  padding: 0;
  margin: 0;
  opacity: 0 !important;
  z-index: 100;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
  cursor: pointer;
}

.show-hide-checkbox:after {
  content: "";
  width: 0;
  height: 0;
  position: absolute;
  border-left: 8px solid transparent;
  border-right: 8px solid transparent;
  border-top: 8px solid #26a69a;
  cursor: pointer;
}

.show-hide-checkbox:checked::after {
  border-left: 8px solid transparent;
  border-right: 8px solid transparent;
  border-bottom: 8px solid #26a69a;
  border-top: none;
}

.show-hide-checkbox:checked + .topic-pairs-search-table__item-main {
  height: 100%;
}

.topic-pairs-search-table__item-main {
    display: grid;
    grid-template-columns: 1fr 1fr 0.5fr;
    min-height: 8rem;
    overflow: hidden;
}

    .topic-pairs-search-table__item-main > :nth-child(2) {
        margin-left: 20px;
    }

.topic-pairs-search-question {
    text-align: left;
    word-break: break-word;
}

.topic-pairs-search-answer-text {
    transition: 0.4s;
    word-wrap: break-word;
    text-align: left;
    word-break: break-word;
    height: 100px;
    overflow: hidden;
}
.topic-pairs-search-answer-text p {
    color: rgba(0, 0, 0, 0.87);
}

.topic-pairs-search-answer-text.opened {
  height: auto;
  overflow: visible;
}

.topic-pairs-search-table__item_info {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
  column-gap: 1rem;
}

    .topic-pairs-search-table__item_info .tag {
        padding: 0.1rem 0.8rem;
        border-radius: 8px;
        border: 1px solid #26a69a;
        color: #26a69a;
        font-size: 1.4rem;
        line-height: 2.4rem;
        max-width: 70%;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        margin-top: 0.5rem;
    }

.topic-pairs-search-question__list {
  margin: 0;
  padding: 0;
}

.topic-pairs-search-button {
    margin-top: auto;
    margin-bottom: auto;
}
    .topic-pairs-search-button button {
        position: relative;
        z-index: 101;
        margin-bottom: 2rem;
    }

.topic-pairs-search-table__item-collapse-button {
  width: 0;
  height: 0;
  margin-top: 8px;
  border-left: 8px solid transparent;
  border-right: 8px solid transparent;
  border-top: 8px solid #26a69a;
  cursor: pointer;
  align-self: center;
}

.topic-pairs-search-table__item-collapse-button.opened {
  border-left: 8px solid transparent;
  border-right: 8px solid transparent;
  border-bottom: 8px solid #26a69a;
  border-top: none;
}

.topic-pairs-search-answer-text .message-item__media {
    min-width: 200px;
    width:auto;
    height: auto;
    max-width: 100%;
    max-height:100px;
}

    .topic-pairs-search-answer-text div {
        line-height:1.5;
        font-size:15px;
    }
`, "",{"version":3,"sources":["webpack://./src/app/nlp/topic-list/topic-item-search/TopicItemSearch.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;EACjB,UAAU;EACV,WAAW;AACb;;AAEA;EACE,0BAA0B;EAC1B,WAAW;EACX,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,oCAAoC;EACpC,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,sBAAsB;EACtB;gCAC8B;EAC9B,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,UAAU;EACV,SAAS;EACT,qBAAqB;EACrB,YAAY;EACZ,SAAS;EACT,OAAO;EACP,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,QAAQ;EACR,SAAS;EACT,kBAAkB;EAClB,kCAAkC;EAClC,mCAAmC;EACnC,6BAA6B;EAC7B,eAAe;AACjB;;AAEA;EACE,kCAAkC;EAClC,mCAAmC;EACnC,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA;IACI,aAAa;IACb,oCAAoC;IACpC,gBAAgB;IAChB,gBAAgB;AACpB;;IAEI;QACI,iBAAiB;IACrB;;AAEJ;IACI,gBAAgB;IAChB,sBAAsB;AAC1B;;AAEA;IACI,gBAAgB;IAChB,qBAAqB;IACrB,gBAAgB;IAChB,sBAAsB;IACtB,aAAa;IACb,gBAAgB;AACpB;AACA;IACI,0BAA0B;AAC9B;;AAEA;EACE,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,2BAA2B;EAC3B,eAAe;EACf,gBAAgB;AAClB;;IAEI;QACI,sBAAsB;QACtB,kBAAkB;QAClB,yBAAyB;QACzB,cAAc;QACd,iBAAiB;QACjB,mBAAmB;QACnB,cAAc;QACd,gBAAgB;QAChB,uBAAuB;QACvB,mBAAmB;QACnB,kBAAkB;IACtB;;AAEJ;EACE,SAAS;EACT,UAAU;AACZ;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;AACvB;IACI;QACI,kBAAkB;QAClB,YAAY;QACZ,mBAAmB;IACvB;;AAEJ;EACE,QAAQ;EACR,SAAS;EACT,eAAe;EACf,kCAAkC;EAClC,mCAAmC;EACnC,6BAA6B;EAC7B,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,kCAAkC;EAClC,mCAAmC;EACnC,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;IACI,gBAAgB;IAChB,UAAU;IACV,YAAY;IACZ,eAAe;IACf,gBAAgB;AACpB;;IAEI;QACI,eAAe;QACf,cAAc;IAClB","sourcesContent":[".topic-search-container {\r\n  height: 100%;\r\n  width: 100%;\r\n}\r\n\r\n.topic-search-header {\r\n    font-size: 4rem;\r\n    font-weight: bold;\r\n    overflow: hidden;\r\n    text-overflow: ellipsis;\r\n}\r\n\r\n.topic-pairs-search-input {\r\n  margin: 1.5rem 4rem;\r\n  height: 4rem;\r\n  line-height: 4rem;\r\n  width: 50%;\r\n  float: left;\r\n}\r\n\r\n.topic-pairs-search-table {\r\n  height: calc(100% - 13rem);\r\n  width: 100%;\r\n  overflow: auto;\r\n  position: relative;\r\n}\r\n\r\n.topic-pairs-search-table__header {\r\n  display: grid;\r\n  grid-template-columns: 1fr 1fr 0.5fr;\r\n  padding: 1rem;\r\n  font-weight: bold;\r\n}\r\n\r\n.topic-pairs-search-table__body {\r\n  padding: 1rem;\r\n}\r\n\r\n.topic-pairs-search-table__item {\r\n  width: 100%;\r\n  height: 100%;\r\n  position: relative;\r\n  margin-top: 1rem;\r\n  margin-bottom: 1rem;\r\n  line-height: 3.5rem;\r\n  background-color: #fff;\r\n  box-shadow: 0 2px 2px 0 rgb(0 0 0 / 14%), 0 3px 1px -2px rgb(0 0 0 / 12%),\r\n    0 1px 5px 0 rgb(0 0 0 / 20%);\r\n  border-radius: 2px;\r\n  padding: 1rem 2rem;\r\n  overflow: hidden;\r\n  min-width: 60rem;\r\n  display: flex;\r\n  flex-direction: column;\r\n}\r\n\r\n.show-hide-checkbox {\r\n  padding: 0;\r\n  margin: 0;\r\n  opacity: 0 !important;\r\n  z-index: 100;\r\n  bottom: 0;\r\n  left: 0;\r\n  width: 100%;\r\n  height: 100%;\r\n  cursor: pointer;\r\n}\r\n\r\n.show-hide-checkbox:after {\r\n  content: \"\";\r\n  width: 0;\r\n  height: 0;\r\n  position: absolute;\r\n  border-left: 8px solid transparent;\r\n  border-right: 8px solid transparent;\r\n  border-top: 8px solid #26a69a;\r\n  cursor: pointer;\r\n}\r\n\r\n.show-hide-checkbox:checked::after {\r\n  border-left: 8px solid transparent;\r\n  border-right: 8px solid transparent;\r\n  border-bottom: 8px solid #26a69a;\r\n  border-top: none;\r\n}\r\n\r\n.show-hide-checkbox:checked + .topic-pairs-search-table__item-main {\r\n  height: 100%;\r\n}\r\n\r\n.topic-pairs-search-table__item-main {\r\n    display: grid;\r\n    grid-template-columns: 1fr 1fr 0.5fr;\r\n    min-height: 8rem;\r\n    overflow: hidden;\r\n}\r\n\r\n    .topic-pairs-search-table__item-main > :nth-child(2) {\r\n        margin-left: 20px;\r\n    }\r\n\r\n.topic-pairs-search-question {\r\n    text-align: left;\r\n    word-break: break-word;\r\n}\r\n\r\n.topic-pairs-search-answer-text {\r\n    transition: 0.4s;\r\n    word-wrap: break-word;\r\n    text-align: left;\r\n    word-break: break-word;\r\n    height: 100px;\r\n    overflow: hidden;\r\n}\r\n.topic-pairs-search-answer-text p {\r\n    color: rgba(0, 0, 0, 0.87);\r\n}\r\n\r\n.topic-pairs-search-answer-text.opened {\r\n  height: auto;\r\n  overflow: visible;\r\n}\r\n\r\n.topic-pairs-search-table__item_info {\r\n  display: flex;\r\n  justify-content: flex-start;\r\n  flex-wrap: wrap;\r\n  column-gap: 1rem;\r\n}\r\n\r\n    .topic-pairs-search-table__item_info .tag {\r\n        padding: 0.1rem 0.8rem;\r\n        border-radius: 8px;\r\n        border: 1px solid #26a69a;\r\n        color: #26a69a;\r\n        font-size: 1.4rem;\r\n        line-height: 2.4rem;\r\n        max-width: 70%;\r\n        overflow: hidden;\r\n        text-overflow: ellipsis;\r\n        white-space: nowrap;\r\n        margin-top: 0.5rem;\r\n    }\r\n\r\n.topic-pairs-search-question__list {\r\n  margin: 0;\r\n  padding: 0;\r\n}\r\n\r\n.topic-pairs-search-button {\r\n    margin-top: auto;\r\n    margin-bottom: auto;\r\n}\r\n    .topic-pairs-search-button button {\r\n        position: relative;\r\n        z-index: 101;\r\n        margin-bottom: 2rem;\r\n    }\r\n\r\n.topic-pairs-search-table__item-collapse-button {\r\n  width: 0;\r\n  height: 0;\r\n  margin-top: 8px;\r\n  border-left: 8px solid transparent;\r\n  border-right: 8px solid transparent;\r\n  border-top: 8px solid #26a69a;\r\n  cursor: pointer;\r\n  align-self: center;\r\n}\r\n\r\n.topic-pairs-search-table__item-collapse-button.opened {\r\n  border-left: 8px solid transparent;\r\n  border-right: 8px solid transparent;\r\n  border-bottom: 8px solid #26a69a;\r\n  border-top: none;\r\n}\r\n\r\n.topic-pairs-search-answer-text .message-item__media {\r\n    min-width: 200px;\r\n    width:auto;\r\n    height: auto;\r\n    max-width: 100%;\r\n    max-height:100px;\r\n}\r\n\r\n    .topic-pairs-search-answer-text div {\r\n        line-height:1.5;\r\n        font-size:15px;\r\n    }\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
